import { Component, OnInit, OnDestroy } from "@angular/core";
import { Location } from "@angular/common";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/app.reducer";
import { ActivatedRoute } from "@angular/router";
import {
  GetGroupDetails,
  RemoveUserFromGroup,
  DeleteGroup,
  UpdateGroup,
  ClearDataForUpdateGroup
} from "../store/user-groups.actions";
import { NotificationModalComponent } from "../../../common-components/notification-modal/notification-modal.component";
import { MatDialog } from "@angular/material/dialog";
import { AddGroupComponent } from "../add-group/add-group.component";
import { NotificationsService } from "angular2-notifications";
import { FormBuilder, FormGroup } from "@angular/forms";
import { tap, takeUntil } from "rxjs/operators";
import { CommonService } from "src/app/services/tasks.services";
import { Subject } from "rxjs";
import { GetConfigurations } from "../../configurations/store/configurations.actions";
import { NgxPermissionsService } from "ngx-permissions";


@Component({
  selector: "group-detail",
  templateUrl: "./group-detail.component.html",
  styleUrls: ["./group-detail.component.scss"]
})
export class GroupDetailComponent implements OnInit, OnDestroy {

  displayedColumns = ["member-name", "remove-member"];
  groupId;
  groupDetails$;
  form: FormGroup;
  groupDetails: any;
  updateButtonClicked: boolean =false;
  private stopper$: Subject<void> = new Subject<void>();
  hideEditGroupDetails: boolean;
  inViewMode;

  constructor(
    private _store: Store<AppState>,
    private location: Location,
    private activateRoute: ActivatedRoute,
    private dialog: MatDialog,
    private notificationService: NotificationsService,
    private fb: FormBuilder,
    private commonService: CommonService,
    private ngxPermissionservice: NgxPermissionsService,
  ) {
    this.activateRoute.params.subscribe(params => {
      this.groupId = params.id;
      this._store.dispatch(new GetGroupDetails(this.groupId));
    });
    this.form =this.fb.group({
      'name': [''],
      'description': ['']
    })
  }

  ngOnInit() {

    if (this.activateRoute.snapshot.url.length) {
      if (this.activateRoute.snapshot.url[1]) {
        this.inViewMode = this.activateRoute.snapshot.url[1].path;
        // && !Object.keys(this.ngxPermissionservice.getPermissions()).includes('edit-group')
        if ( this.inViewMode == "view" ) {
          this.hideEditGroupDetails = true;
        } else {
          this.hideEditGroupDetails = false;
        }
      }
    }


    this.groupDetails$ = this._store.select(
      state => state.userGroups.groupDetails
    ).pipe(tap((data) => {
    this.groupDetails =data;
      if(data && Object.keys(data).length) {
        this.form.setValue ({
          'name': data.name || '',
          'description': data.description || ''
        })

      }
    }));
    this._store.select(state => state.userGroups.updateGroup).pipe(takeUntil(this.stopper$)).subscribe((response) => {
      if(response && Object.keys(response).length && this.updateButtonClicked) {
        this.notificationService.success('Details updated successfully');
      }
    })
    this._store.dispatch(new GetConfigurations())
    this._store.select(state => state.configurations.configurations
      ).pipe(takeUntil(this.stopper$)).subscribe((resp: any) => console.log(resp, "heres"));
  }

  cancel() {
    this.location.back();
  }

  RemoveConfirmation() {
    const dialogRef = this.dialog.open(NotificationModalComponent, {
      width: "500px",
      panelClass:'cmp-modal',
      data: {
        text: "Are you sure you want to delete this group?"
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._store.dispatch(new DeleteGroup(this.groupId));
      }
    });
  }

  goToEditGroup(datum) {
    const dialogRef = this.dialog.open(AddGroupComponent, {
      width: "60%",
      data: datum,
      panelClass : 'cmp-modal',
    });
    dialogRef.afterClosed().subscribe(result => {
      //in second tab write what needs to be done after closed;
      if(result && result.type === 'getUserDetails') {
        this.notificationService.success(result.resp[0].message);
        this._store.dispatch(new GetGroupDetails(this.groupId));
      }
   

    });
  }

  removeUser(user) {
    if (this.groupDetails.users.length <= 2) {
        this.notificationService.error("Group should have minimum 2 members");
        return;
    }

    const dialogRef = this.dialog.open(NotificationModalComponent, {
      width: "500px",
      panelClass:'cmp-modal',
      data: {
        text: `Are you sure you want to remove ${
          user.firstName
        } ${user.middleName || ""} ${user.lastName} from this group?`
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._store.dispatch(new RemoveUserFromGroup(this.groupId, user._id));
      }
    });
  }
  tabChange(event) {
    if(event.index === 1) {
      this.updateButtonClicked =false
    }
  }
  updateClicked() {
    console.log(this.form.value, "formValu")
    this.updateButtonClicked =true;
    this._store.dispatch(new UpdateGroup(this.groupDetails._id,this.form.value) )

  }
  ngOnDestroy() {
    this.stopper$.next();
    this._store.dispatch(new ClearDataForUpdateGroup())
  }
}
